import React, { Fragment, useEffect, useState } from 'react'
import NavbarsTab from '../../A-RKS/NavBar'
import ProductFeatures from '../../Components/App/Ecommerce/Products/ProductFeatures'
import ProductGrid from '../../Components/App/Ecommerce/Products/ProductGrid'
import { Card, CardBody, Container } from 'reactstrap'
import { Breadcrumbs } from '../../AbstractElements'
import { getCategoryOptions, productView } from '../../CommonUrl'
import { getClientUrlDataToken, getData } from '../../Utils/restUtils'
import Transparentspinner from '../../Components/Common/Loader/Transparentspinner'
import Footer from '../../A-RKS/Footer'

const ProductShop = () => {
  const [apiResponse, setApiResponse] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading,setLoading]=useState(false)
  const perPage = 8;

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    setLoading(true)
    const response = await getClientUrlDataToken(productView);
    setApiResponse(response?.data?.data || []);
    setLoading(false)
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <NavbarsTab />
      <Fragment>
        {
          loading &&
          <Transparentspinner/>
        }
        <Container fluid={true} className="product-wrapper">
          <div className="product-grid">
            <ProductFeatures />
            <Card className="mt-4 p-3 border">
              <CardBody>
                <ProductGrid
                  productList={apiResponse}
                  perPage={perPage}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </CardBody>
            </Card>
          </div>
        </Container>
      </Fragment>
      <Footer/>
    </>
  );
};

export default ProductShop